var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEncryption(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.499512,
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#ABBBF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4995 10.5H14.9995V9.49998C14.9995 8.11999 13.8795 7 12.4995 7C11.1195 7 9.99951 8.11999 9.99951 9.49998V10.5H9.49951C8.94951 10.5 8.49951 10.95 8.49951 11.5V16.4999C8.49951 17.0499 8.94951 17.4999 9.49951 17.4999H15.4995C16.0495 17.4999 16.4995 17.0499 16.4995 16.4999V11.5C16.4995 10.95 16.0495 10.5 15.4995 10.5ZM12.4995 14.9999C11.9495 14.9999 11.4995 14.5499 11.4995 13.9999C11.4995 13.4499 11.9495 12.9999 12.4995 12.9999C13.0495 12.9999 13.4995 13.4499 13.4995 13.9999C13.4995 14.5499 13.0495 14.9999 12.4995 14.9999ZM14.0495 10.5H10.9495V9.49998C10.9495 8.64498 11.6445 7.94999 12.4995 7.94999C13.3545 7.94999 14.0495 8.64498 14.0495 9.49998V10.5Z",
    fill: "#F6F7FE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEncryption);
export default __webpack_public_path__ + "static/media/encryption.43e1c595fc44feee4514d624f4b86816.svg";
export { ForwardRef as ReactComponent };